module.exports = __webpack_public_path__ + "static/e-illu-3-8f3f9d388e1bccc6e8bc62d31a44224b.png";